import { safeParseJSON } from "@src/shared/helpers/object";
import { ValidationResult } from "./buildValidationResult";
import {
  useParseValidationResult,
  UseValidationErrorParserOptions,
} from "./useParseValidationResult";
import { ZOD_VALIDATION_RESULT_PREFIX } from "./zodValidationResult";

export function isZodValidationResult(error: string): boolean {
  return error.startsWith(ZOD_VALIDATION_RESULT_PREFIX);
}

export function useParseZodValidationResult(
  options?: UseValidationErrorParserOptions,
) {
  const parseValidationResult = useParseValidationResult(options);

  return (error: string) => {
    if (isZodValidationResult(error)) {
      const validationResult = safeParseJSON<ValidationResult>(
        error.replace(ZOD_VALIDATION_RESULT_PREFIX, ""),
      );
      if (!validationResult) return error;
      return parseValidationResult(validationResult);
    }
    return error;
  };
}
